import { IDocumentIdentifiable } from "./IDocumentIdentifiable";

export class DocumentIdentifier implements IDocumentIdentifiable {
  constructor(
    public readonly id: number,
    public readonly patientNo: string
  ) {
  }
}
